module.exports = __webpack_public_path__ + "static/media/Memb-I-00131_0018.b8a9e50a.jpg";